import { createStore } from 'vuex';
import moduleI18n from './i18n';

const moduleUser = {
  state: {    
    userData:null
  },
  mutations:{    
    defineUserData(state,data){
      /**console.log("define Locale:",data);*/
      state.userData=data;
    },
    clearUserData(state){      
      /**console.log("clear Locale:",state.locale);*/
      state.userData=null;      
    }
  },
  actions: {    
    retrieveUserData({commit,state}){
      /**console.log("retrieveLocale:{}",state.locale);*/
      if(state.userData === null || state.userData === "undefined"){
        if (typeof Storage !== "undefined") {
          const _usrdata=sessionStorage.getItem("userData");        
          if(_usrdata){
            commit('defineUserData',JSON.parse(_usrdata));   
          }
        }
      }      
    },
    createUserData({commit},payload){         
      commit('defineUserData',payload); 
    },
    removeUserData(context){             
      context.commit('clearUserData'); 
    }

    
  }
};

const moduleProdSupport = {
  state: {    
    classifications:null,
    categories:null
  },
  mutations:{    
    defineProdCategories(state,data){      
      state.categories=data;
    },
    clearProdCategories(state){            
      state.categories=null;      
    },
    defineProdClassifications(state,data){      
      state.classifications=data;
    },
    clearProdClassifications(state){            
      state.classifications=null;      
    }
  },
  actions: {        
    createProdCategories({commit},payload){         
      commit('defineProdCategories',payload); 
    },
    removeProdCategories(context){             
      context.commit('clearProdCategories'); 
    },
    createProdClassifications({commit},payload){         
      commit('defineProdClassifications',payload); 
    },
    removeProdClassifications(context){             
      context.commit('clearProdClassifications'); 
    }
  }
};

const moduleAppSupport = {
  state: {    
    menu:null
  },
  mutations:{    
    defineMenu(state,data){      
      state.menu=data;
    },
    clearMenu(state){            
      state.menu=null;      
    }
  },
  actions: {        
    createMenu({commit},payload){         
      commit('defineMenu',payload); 
    },
    removeMenu(context){             
      context.commit('clearMenu'); 
    }
  }
};



export default createStore({
  state: {
    cart: null,
    subjectId:null,
    title:null,
    currency: null,
    pointRate: null,
  },
  mutations: {
    defineCart(state,data){
      /** console.log("defineCart:",data); */
      state.cart=data;
    },
    clearCart(state){
      state.cart=null;
    },
    defineTitle(state,data){
      /** console.log("defineTitle:",data); */
      state.title=data;
    },
    clearTitle(state){
      state.title=null;
    },
    defineSubjectId(state,data){
      /** console.log("subjectId:",data); */
      state.subjectId=data;
    },
    clearSubjectId(state){      
      /** console.log("clear subjectId:"+state.subjectId); */
      state.subjectId=null;      
    },
    defineCurrency(state,data){
      /** console.log("currency:",data);*/
      state.currency=data;
    },
    clearCurrency(state){      
      /** console.log("currency:"+state.currency); */
      state.currency=null;      
    },
    definePointRate(state,data){
      /** console.log("pointRate:",data);*/
      state.pointRate=data;
    },
    clearPointRate(state){      
      /** console.log("pointRate:"+state.pointRate); */
      state.pointRate=null;      
    },
  },
  actions: {
    retrieveCart({commit,state}){
      /** console.log("retrieveToken:{}",state.cart); */
      if(state.cart === null || state.cart === "undefined"){
        if (typeof Storage !== "undefined") {
          let cart=sessionStorage.getItem("cart");        
          if(cart){        
            commit('defineCart',cart);   
          }
        }
      }
    },    
    createCart({commit},payload){ 
      /** alert('createToken'); */
      commit('defineCart',payload); 
    },
    removeCart(context){             
      context.commit('clearCart'); 
    },
    
    retrieveSubjectId({commit,state}){
      /** console.log("retrieveSubjectId:{}",state.subjectId); */
      if(state.subjectId === null || state.subjectId === "undefined"){
        if (typeof Storage !== "undefined") {
          let subjectId=sessionStorage.getItem("subjectId");        
          if(subjectId){        
            commit('defineSubjectId',subjectId);   
          }
        }
      }
      
    },    
    createSubjectId({commit},payload){
      commit('defineSubjectId',payload); 
    },
    removeSubjectId(context){             
      context.commit('clearSubjectId'); 
    },

    retrieveTitle({commit,state}){
      /** console.log("retrieveTitle:{}",state.title); */
      if(state.title === null || state.title === "undefined"){
        if (typeof Storage !== "undefined") {
          let title=sessionStorage.getItem("title");        
          if(!title||title.length==0){                    
            title=process.env.VUE_APP_QUOTE;
          }
          commit('defineTitle',title); 
        }
      }
      
    },    
    createTitle({commit},payload){
      commit('defineTitle',payload); 
    },
    removeTitle(context){             
      context.commit('clearTitle'); 
    },

    retrieveCurrency({commit,state}){
      /** console.log("retrieveCurrency:{}",state.currency); */
      if(state.currency === null || state.currency === "undefined"){
        if (typeof Storage !== "undefined") {
          let currency=sessionStorage.getItem("currency");        
          if(currency){        
            commit('defineCurrency',currency);   
          }
        }
      }      
    },    
    createCurrency({commit},payload){         
      commit('defineCurrency',payload); 
    },
    removeCurrency(context){             
      context.commit('clearCurrency'); 
    },

    retrievePointRate({commit,state}){
      /** console.log("retrieveCurrency:{}",state.currency); */
      if(state.pointRate === null || state.pointRate === "undefined"){
        if (typeof Storage !== "undefined") {
          let pointRate=sessionStorage.getItem("pointRate");        
          if(pointRate){        
            commit('definePointRate',pointRate);   
          }
        }
      }      
    },    
    createPointRate({commit},payload){         
      commit('definePointRate',payload); 
    },
    removePointRate(context){             
      context.commit('clearPointRate'); 
    }
  },
  modules: {
    user:  moduleUser,
    prodSupport: moduleProdSupport,
    appSupport:moduleAppSupport,
    i18n: moduleI18n
  }
});
